import { WarningAmber } from 'components/icons';
import { Alert, AlertDescription } from 'components/ui/alert';
import { ReactNode } from 'react';

export const WARNING_ROW_CLASS = 'border-warning bg-warning-light';

export const NEW_TAB_LINK_CLASS = 'text-link w-fit no-underline hover:underline';

/**
 * A row is static content, so it is a note by default; the kit `Alert` would make every row a live alert announced the
 * moment the modal opens.
 */
export function WarningRow({ children, role = 'note' }: { children: ReactNode; role?: 'note' | 'alert' }) {
    return (
        <Alert role={role} className={WARNING_ROW_CLASS}>
            <WarningAmber className="text-warning size-4" />
            <AlertDescription className="text-foreground text-body2 flex w-full flex-col gap-1">
                {children}
            </AlertDescription>
        </Alert>
    );
}

export function NewTabLink({ href, children }: { href: string; children: ReactNode }) {
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={NEW_TAB_LINK_CLASS}>
            {children}
        </a>
    );
}
